import {createRouter, createWebHistory} from "vue-router";
// ACCOUNT PAGES
import SignIn from "@/components/Auth/SignIn.vue";
import Registration from "@/components/Auth/Registration.vue";
import ForgotPass from "@/components/Auth/ForgotPass.vue";
import ResetPass from "@/components/Auth/ResetPass.vue";
import ProfilePage from "@/pages/ProfilePage.vue";
// ACTIVATION PAGES
import ActivationViberPage from "@/pages/ActivationViberPage.vue";
import ActivationTelegramPage from "@/pages/ActivationTelegramPage.vue";
import ActivationWhatsappPage from "@/pages/ActivationWhatsappPage.vue";
import SuccessActivationPage from "@/pages/SuccessActivationPage.vue";
// MENU PAGES
import Home from "@/views/Home.vue";
import IntegrationPage from "@/pages/IntegrationPage.vue";
import TariffsPage from "@/pages/TariffsPage.vue";
import ActivationAdvancePage from "@/pages/ActivationAdvancePage.vue";
import SubscriptionPage from "@/pages/SubscriptionPage.vue";
// CRMs INSTRUCTION PAGES
import ApixDrivePage from "@/pages/InstructionApixDrivePage";
import KeyCrmPage from "@/pages/InstructionKeyCrmPage";
import PlanFixPage from "@/pages/InstructionPlanFixPage";
import Bitrix24Page from "@/pages/InstructionBitrix24Page";
import TrendCRMPage from "@/pages/InstructionTrendCRMPage";
import OneBoxPage from "@/pages/InstructionOneBoxPage";
import WepsterPage from "@/pages/InstructionWepsterPage";
import KommoPage from "@/pages/InstructionKommoPage.vue";
import CreatioPage from "@/pages/InstructionCreatioPage.vue";
import PerfectumPage from "@/pages/InstructionPerfectumPage.vue";
import KeepinPage from "@/pages/InstructionKeepinPage.vue";
import SalesDrivePage from "@/pages/InstructionSalesDrivePage.vue";
import RoAppPage from "@/pages/InstructionRoAppPage.vue";
import ConnectiveOnePage from "@/pages/InstructionConnectiveOnePage.vue";
import GPlusPage from "@/pages/InstructionGPlusPage.vue";
import NovaTalksPage from "@/pages/InstructionNovaTalksPage.vue";
import LBSPage from "@/pages/InstructionLBSPage.vue";
import UspacyPage from "@/pages/InstructionUspacyPage.vue";
import ApiPage from "@/pages/InstructionApiPage";
import OdooPage from "@/pages/InstructionOdooPage.vue";
import NetHunt from "@/pages/InstructionNetHuntPage.vue";
import EasyBusyPage from "@/pages/InstructionEasyBusyPage.vue";
import AmplooPage from "@/pages/InstructionAmplooPage.vue";
import SitniksPage from "@/pages/InstructionSitniksPage.vue";
import SendPulsePage from "@/pages/InstructionSendPulsePage.vue";
import CleverBoxPage from "@/pages/InstructionCleverBoxPage.vue";
import VoipTimePage from "@/pages/InstructionVoipTimePage.vue";
import TradeEvoPage from "@/pages/InstructionTradeEvoPage.vue";
import PagerPage from "@/pages/InstructionPagerPage.vue"


// Telepohony
import TelephonyStatistics from "@/pages/Telephony/Statistics.vue"
import TelephonySettings from "@/pages/Telephony/Settings.vue"
import TelephonyActivation from "@/pages/Telephony/Activation.vue"
import TiktokActivation from "@/pages/Tiktok/Activation.vue"

// OTHER
import OopsPage from "@/pages/OopsPage.vue";

import {useStore} from "vuex";

const generatePath = (pathName) => `/profile/${pathName}`;

export const AFTER_LOGIN_PATH = "afterLoginPath";

const routes = [
    {
        path: generatePath(""),
        name: "Home",
        component: Home,
        // redirect: {
        //     name: "Integration",
        // },
        meta: { requiresAuth: true, seo: { page: "integrations" } },
    },
    {
        path: generatePath("login"),
        name: "SignIn",
        component: SignIn,
        meta: { requiresAuth: false, seo: { page: "login" } },
    },
    {
        path: generatePath("registration"),
        name: "Registration",
        component: Registration,
        meta: { requiresAuth: false, seo: { page: "registration" } },
        props: true,
    },
    {
        path: generatePath("forgot-password"),
        name: "ForgotPass",
        component: ForgotPass,
        meta: { requiresAuth: false, seo: { page: "forgot_password" } },
    },
    {
        path: generatePath("reset-password"),
        name: "ResetPass",
        component: ResetPass,
        meta: { requiresAuth: false, seo: { page: "reset_password" } },
    },
    {
        path: generatePath("integration/:number?"),
        name: "Integration",
        component: IntegrationPage,
        meta: { requiresAuth: true, seo: { page: "integrations" } },
    },
    {
        path: generatePath("tariffs"),
        name: "Tariffs",
        component: TariffsPage,
        meta: { requiresAuth: true, seo: { page: "tariffs" } },
    },
    {
        path: generatePath('tariffs/advance'),
        name: "AdvanceActivation",
        component: ActivationAdvancePage,
        meta: { requiresAuth: true, activePage: "Tariffs", seo: { page: "tariffs_advance" } },
    },
    {
        path: generatePath('tariffs/subscription'),
        name: "Subscription",
        component: SubscriptionPage,
        meta: { requiresAuth: true, activePage: "Tariffs", seo: { page: "tariffs_subscription" } },
    },
    {
        path: generatePath("activation-viber/:number"),
        name: "ActivationViber",
        component: ActivationViberPage,
        props: true,
        meta: { requiresAuth: true, seo: { page: "activation_viber" } },
    },
    {
        path: generatePath("activation-telegram/:number?"),
        name: "ActivationTelegram",
        component: ActivationTelegramPage,
        meta: { requiresAuth: true, seo: { page: "activation_telegram" } },
    },
    {
        path: generatePath("activation-whatsapp/:number?"),
        name: "ActivationWhatsapp",
        component: ActivationWhatsappPage,
        meta: { requiresAuth: true, seo: { page: "activation_whatsapp" } },
    },
    {
        path: generatePath("success-activation"),
        name: "SuccessActivation",
        component: SuccessActivationPage,
        meta: { requiresAuth: true, seo: { page: "success_activation" } },
    },
    {
        path: generatePath("oops"),
        name: "Oops",
        component: OopsPage,
        meta: { requiresAuth: true, seo: { page: "oops" } },
    },
    {
        path: generatePath("apix-drive"),
        name: "Apix-Drive",
        component: ApixDrivePage,
        meta: { requiresAuth: true, seo: { integration: "ApiX-Drive" } },
    },
    {
        path: generatePath("wepster"),
        name: "Wepster",
        component: WepsterPage,
        meta: { requiresAuth: true, seo: { integration: "Wepster" } },
    },
    {
        path: generatePath("api"),
        name: "API",
        component: ApiPage,
        meta: { requiresAuth: true, seo: { page: "api" } },
    },
    {
        path: generatePath("plan-fix"),
        name: "PlanFix",
        component: PlanFixPage,
        meta: { requiresAuth: true, seo: { integration: "PlanFix" } },
    },
    {
        path: generatePath("trend-crm"),
        name: "TrendCRM",
        component: TrendCRMPage,
        meta: { requiresAuth: true, seo: { integration: "TrendCRM" } },
    },
    {
        path: generatePath("onebox"),
        name: "OneBox",
        component: OneBoxPage,
        meta: { requiresAuth: true, seo: { integration: "OneBox" } },
    },
    {
        path: generatePath("keepin"),
        name: "KeepinCRM",
        component: KeepinPage,
        meta: { requiresAuth: true, seo: { integration: "KeepinCRM" } },
    },
    {
        path: generatePath("key-crm"),
        name: "KeyCRM",
        component: KeyCrmPage,
        meta: { requiresAuth: true, seo: { integration: "KeyCRM" } },
    },
    {
        path: generatePath("bitrix24"),
        name: "Bitrix24",
        component: Bitrix24Page,
        meta: { requiresAuth: true, seo: { integration: "Bitrix24" } },
    },
    {
        path: generatePath("kommo-crm"),
        name: "KommoCRM",
        component: KommoPage,
        meta: { requiresAuth: true, seo: { integration: "Kommo" } },
    },
    {
        path: generatePath("perfectum"),
        name: "Perfectum",
        component: PerfectumPage,
        meta: { requiresAuth: true, seo: { integration: "Perfectum" } },
    },
    {
        path: generatePath("creatio"),
        name: "Creatio",
        component: CreatioPage,
        meta: { requiresAuth: true, seo: { integration: "Creatio" } },
    },
    {
        path: generatePath("sales-drive"),
        name: "SalesDrive",
        component: SalesDrivePage,
        meta: { requiresAuth: true, seo: { integration: "SalesDrive" } },
    },
    {
        path: generatePath("roapp"),
        name: "ROapp", // RemOnline
        component: RoAppPage,
        meta: { requiresAuth: true, seo: { integration: "ROapp" } },
    },
    {
        path: generatePath("odoo"),
        name: "Odoo",
        component: OdooPage,
        meta: { requiresAuth: true, seo: { integration: "Odoo" } }
    },
    {
        path: generatePath("nethunt"),
        name: "NetHunt",
        component: NetHunt,
        meta: { requiresAuth: true, seo: { integration: "NetHunt" } }
    },
    {
        path: generatePath("amploo"),
        name: "Amploo",
        component: AmplooPage,
        meta: { requiresAuth: true, seo: { integration: "Amploo" } }
    },
    {
        path: generatePath("sitniks"),
        name: "Sitniks",
        component: SitniksPage,
        meta: { requiresAuth: true, seo: { integration: "Sitniks" } }
    },
    {
        path: generatePath("connectiveone"),
        name: "ConnectiveOne",
        component: ConnectiveOnePage,
        meta: { requiresAuth: true, seo: { integration: "ConnectiveOne" } },
    },
    {
        path: generatePath("g-plus"),
        name: "G-plus",
        component: GPlusPage,
        meta: { requiresAuth: true, seo: { integration: "G-Plus" } },
    },
    {
        path: generatePath("novatalks"),
        name: "NovaTalks",
        component: NovaTalksPage,
        meta: { requiresAuth: true, seo: { integration: "NovaTalks" } },
    },
    {
        path: generatePath("lbs"),
        name: "LBS",
        component: LBSPage,
        meta: { requiresAuth: true, seo: { integration: "LBS" } },
    },
    {
        path: generatePath("uspacy"),
        name: "Uspacy",
        component: UspacyPage,
        meta: { requiresAuth: true, seo: { integration: "Uspacy" } },
    },
    {
        path: generatePath('easybusy'),
        name: 'EasyBusy',
        component: EasyBusyPage,
        meta: { requiresAuth: true, seo: { integration: "EasyBusy" } }
    },
    {
        path: generatePath('sendPulse'),
        name: 'SendPulse',
        component: SendPulsePage,
        meta: { requiresAuth: true, seo: { integration: "SendPulse" } }
    },
    {
        path: generatePath('cleverBox'),
        name: 'CleverBox',
        component: CleverBoxPage,
        meta: { requiresAuth: true, seo: { integration: "CleverBox" } }
    },
    {
        path: generatePath('voipTime'),
        name: 'VoipTime',
        component: VoipTimePage,
        meta: { requiresAuth: true, seo: { integration: "VoipTime" } }
    },
    {
        path: generatePath('tradeEvo'),
        name: 'TradeEVO',
        component: TradeEvoPage,
        meta: { requiresAuth: true, seo: { integration: "TradeEVO" } }
    },
    {
        path: generatePath('pager'),
        name: 'PagerPage',
        component: PagerPage,
        meta: { requiresAuth: true, seo: { integration: "Pager" } }
    },
    // PagerPage
    {
        path: generatePath("user-info"),
        name: "UserInfo",
        component: ProfilePage,
        meta: { requiresAuth: true, seo: { page: "user_info" } },
    },
    {
        path: generatePath("telephony-statistics"),
        name: "TelephonyStatistics",
        component: TelephonyStatistics,
        meta: { requiresAuth: true, earlyAccess: true, seo: { page: "telephony_statistics" } },
    },
    {
        path: generatePath("telephony-settings"),
        name: "TelephonySettings",
        component: TelephonySettings,
        meta: { requiresAuth: true, earlyAccess: true, seo: { page: "telephony_settings" } },
    },
    {
        path: generatePath("telephony-activation"),
        name: "TelephonyActivation",
        component: TelephonyActivation,
        meta: { requiresAuth: true, earlyAccess: true, seo: { page: "telephony_activation" } },
    },
    {
        path: generatePath("tiktok-activation"),
        name: "TiktokActivation",
        component: TiktokActivation,
        meta: { requiresAuth: true, earlyAccess: true, seo: { page: "tiktok_activation" } },
    },
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    base: process.env.VUE_APP_PATH,
    mode: "history",
    routes,
});

function findNavItem(items, name) {
    for (const item of items) {
        if (item.name === name) {
            return item
        }
        if (item.children) {
            const found = findNavItem(item.children, name)
            if (found) {
                return found
            }
        }
    }
    return null
}

router.beforeEach((to, from, next) => {
    const store = useStore();
    const _name = to.name === "Home" ? 'Integration' : to.name
    const navItem = findNavItem(store.state.navBar.menu, _name)
    if (!!navItem && navItem.name !== from?.name) {
        store.dispatch('navBar/setActiveKeys', navItem)
    }
    if (to.query?.redirect === "admin-profile") {
        // console.log("Перенаправление на страницу профиля администратора");
        store.dispatch("auth/setTokenFromCookies");
        return next();
    }

    if (from.name === 'SignIn' && to.name === 'Home') {
        store.commit('setIsRelogin', true)
    } else if (store.getters.getIsRelogin) {
        store.commit('setIsRelogin', false)
    }

    const exists = routes.some((route) => {
        return to.name === route.name;
    }); // Проверка, существует ли маршрут

    if (!exists) {
        return next({ name: "Home" });
    }

    const isAuthenticated = store.getters["auth/isLoggedIn"];
    const isAdmin = store.getters["auth/isAdmin"];
    const requiresAuth = to.meta.requiresAuth;
    const requiresAdmin = to.meta.requiresAdmin;

    // если пользователь авторизован и роутер не требует авторизации
    if (isAuthenticated && !requiresAuth) {
        // console.log("Пользователь авторизован и роутер не требует авторизации");
        return next({ name: "Home" });
    }
    // если пользователь не авторизован и роутер требует авторизации
    if (requiresAuth && !isAuthenticated && !localStorage.getItem("token")) {
        // the target path (query included) is restored right after the login,
        // otherwise a deep link - like the tiktok activation result - is lost
        sessionStorage.setItem(AFTER_LOGIN_PATH, to.fullPath);
        return next({ name: "SignIn" });
    }

    // telephony and TikTok pages stay closed to a direct link or a bookmark
    if (to.meta.earlyAccess && !store.getters["auth/hasEarlyAccess"]) {
        return next({ name: "Home" });
    }

    return next();
});

export default router;
